export const VIDEO_GROUP_RATINGS: Record<string, number> = {
  renderforest: 9.0, // max of Fast 6 / Pro 9
  bytePlus: 9.0, // Seedance 2.5
  kling: 8.8, // Kling 3.0 Omni
  google: 8.8, // Veo
  miniMax: 8.8, // MiniMax H3
  pixVerse: 7.0, // max across V6 / C1 / V5
  flux: 8.9 // Flux 3
}

export const VIDEO_VARIANT_RATINGS: Record<string, number> = {
  // Renderforest
  'forest-1.0': 6.0, // Fast
  'forest-1.0-pro': 9.0, // Pro
  'renderforest-pro': 9.0, // Pro (live model code)

  // Seedance (bytePlus)
  'dreamina-seedance-2.5': 9.0, // Seedance 2.5
  'dreamina-seedance-2.0': 8.8, // Seedance 2.0
  'dreamina-seedance-2.0-fast': 8.5, // Seedance 2.0 Fast
  'dreamina-seedance-2.0-mini': 8.5, // Seedance 2.0 Mini
  'seedance-1.5-pro': 7.5, // Seedance 1.5 pro

  // Kling
  'kling-v3-omni': 8.8, // 3.0 Omni
  'kling-v3-omni-with-sound': 8.8, // 3.0 Omni With Audio
  'kling-v2.6': 8.0, // 2.6

  // Pixverse
  'pixverse-v6': 7.0,
  'pixverse-c1': 7.0,
  'pixverse-v5': 6.0,

  // Veo
  'veo-3.1-fast': 8.8,

  // MiniMax
  'minimax-h3': 8.8,

  // Flux
  'flux-3': 8.9
}
